// Type stubs for desktop integration.
//
// yoDEV does not ship the AFFiNE desktop (Electron) app. The original
// `@affine/electron` workspace was removed; its types lived in source files
// under that workspace, so the imports below were replaced with `any` stubs.
//
// Runtime values (`appInfo`, `apis`, `events`, `sharedStorage`) remain unchanged:
// they read from `globalThis` and resolve to `null`/`undefined` in a web build,
// which is what consumers already expect (every call site null-checks before use,
// and the consumers that don't are inside `if (isInDesktop)` branches that are
// dead code on web). Types are erased at compile time so the lack of real
// definitions doesn't change runtime behavior.
type ElectronStub = any;

export type ClientHandler = ElectronStub;
export type ClientEvents = ElectronStub;
export type AppInfo = ElectronStub;
export type SharedStorage = ElectronStub;
export type SpellCheckStateSchema = ElectronStub;
export type SpellCheckStateKey = ElectronStub;
export type TabViewsMetaSchema = ElectronStub;
export type WorkbenchMeta = ElectronStub;
export type WorkbenchViewMeta = ElectronStub;
export type WorkbenchViewModule = ElectronStub;
export type UpdateMeta = ElectronStub;
export type AddTabOption = ElectronStub;
export type TabAction = ElectronStub;
export type MeetingSettingsSchema = ElectronStub;
export type MeetingSettingsKey = ElectronStub;
export type MenubarStateSchema = ElectronStub;
export type MenubarStateKey = ElectronStub;

export const appInfo = (globalThis as any).__appInfo as AppInfo | null;
export const apis = (globalThis as any).__apis as ClientHandler | undefined;
export const events = (globalThis as any).__events as ClientEvents | undefined;
export const sharedStorage = (globalThis as any).__sharedStorage as
  | SharedStorage
  | undefined;
